import React from 'react'
import { Icon } from 'semantic-ui-react'
import moment from 'moment'
import { getQueryVariable } from '../../../../apiCalls/jobInfo'

let options = {
    timeZone: 'Europe/Madrid',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
}

const statusEnum = {
    REJECTED: {status: "REJECTED", color: "red", icon: "warning circle"},
    ACCEPTED: {status: "ACCEPTED", color: "green", icon: "check circle"},
    APPROVAL_PENDING: {status: "APPROVAL PENDING", color: "#FFB800"}
}


const StatusDetailItemTitle = ({enableRawXml, item, index, translate=(item)=>(item)}) => {
    const isEngine = getQueryVariable('onlyOneShipment');

    let pathXmlRaw = `/broker-panel/xml-preview/${window.shipmentCountry}/${item.shipmentId}/response/${item.id}`

    if(isEngine){
        const env = window.location.ancestorOrigins[0]
        // pathXmlRaw = `${env}/xml/xml-preview/${window.shipmentCountry}/${item.shipmentId}/${item.type}/${item.id}` 
        pathXmlRaw = `${env}/xml/xml-preview/${window.shipmentCountry}/${item.shipmentId}/response/${item.id}` 
    }

    return ( 
        <>
            <div className={`sh sh${item.transactionType || ''}`}>
                {/* <img src={downArrow}></img> */}
                <span style={{"width": "23%"}}>
                    <b>{translate("SHIP ID") + ": " }</b>
                    {item.shipmentId}
                </span>
                <span style={{"width": "30%"}}>
                    <b>CREATION DATE: </b>
                    {moment(parseInt(item?.createdDate?.epochs)).tz("America/New_York").format('MMM DD YYYY HH:mm:ss')}
                </span>
                <span style={{"width": "15%"}}>
                    <b>{translate("TYPE")+": "} </b>
                    {
                    <Icon name={statusEnum[item.type]?.icon} color={statusEnum[item.type]?.color} style={{"display": "inline"}}/>
                    } 
                    <b style={{color: statusEnum[item.type]?.color}}>{statusEnum[item.type]?.status}</b>
                </span>
                {/* <span style={{"width": "25%"}}>
                    <b>{translate("STATUS") +": "}</b>
                    {
                    item.status?.toLowerCase().includes("fail") || item.status?.toLowerCase().includes("error")? 
                    <Icon name='warning circle' color='red' style={{"display": "inline"}}/>: 
                    <Icon name='check circle' color='green' style={{"display": "inline"}}/>
                    } 
                    <b style={{color: item.status?.toLowerCase().includes("fail") || item.status?.toLowerCase().includes("error") ?"red":"green"}}>{item.status}</b>
                </span> */}
                <span style={{"width": "7%"}}><a target='_blank' href={pathXmlRaw}><b>Raw XML</b></a></span>
            </div>
        </>
     );
}
 
export default StatusDetailItemTitle;